import Layout from 'components/Layout';
import AppShell from 'components/Layout/AppShell';
import QRCode from 'react-qr-code';
import useLiterals from 'utils/hooks/useLiterals';
import { toast } from 'react-toastify';
import { copyToClipboard } from 'utils/events';
import InlineError from 'components/UI/InlineError';
import Barcode from 'react-barcode';
import { useState } from 'react';
import Select from 'components/UI/Select';
import useKLU from 'hooks/useKLU';
import './styles.scss';

const MODE_QR = 'qr';
const MODE_BARCODE = 'barcode';

const InterbankKey = () => {
  const literals = useLiterals('interbankKey');
  const klu = useKLU();
  const [mode, setMode] = useState(MODE_BARCODE);

  const handleCopy = () => {
    copyToClipboard(klu.account).then((success) => {
      if (success) {
        toast.success(literals.copySuccess, {
          autoClose: 2000,
        });
      } else {
        toast.error(literals.copyError, {
          autoClose: 2000,
        });
      }
    });
  };

  return (
    <Layout bottomMenu onBack className='interbank-key-layout'>
      <AppShell variant='narrow'>
        <h1>{literals.title}</h1>
        {!klu.account || !klu.enabled ? (
          <InlineError className='mt-12 mb-6' error={literals.noAccount} />
        ) : (
          <>
            <p>{literals.thisIsYourInterbankKey}</p>
            <Select
              className='mt-6'
              options={[
                { label: literals.barcode, value: MODE_BARCODE },
                { label: literals.qr, value: MODE_QR },
              ]}
              value={mode}
              canBeEmpty={false}
              onChange={(value) => setMode(value)}
            />
            <div className='mt-12' onClick={handleCopy}>
              {mode === MODE_QR && (
                <div className='qr-wrapper'>
                  <QRCode
                    size={200}
                    style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
                    value={klu.account}
                    viewBox='0 0 256 256'
                  />
                  <p className='text-center mt-4 text-lg'>{klu.account}</p>
                </div>
              )}
              {mode === MODE_BARCODE && (
                <div className='barcode-wrapper'>
                  <Barcode height={150} value={klu.account} />
                </div>
              )}
            </div>
          </>
        )}
      </AppShell>
    </Layout>
  );
};

export default InterbankKey;
